import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Tabs,
  Tab,
  Button,
  Typography,
} from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import SchoolIcon from "@mui/icons-material/School";
import { useNavigate } from "react-router-dom";
import TeacherExcelUpload from "../home/TeacherExcelUpload";
import StudentExcelUpload from "../components/students/StudentExcelUpload";

function AnimatedTabPanel({ children, value, index }) {
  return (
    <AnimatePresence mode="wait">
      {value === index && (
        <motion.div
          key={index}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.4 }}
        >
          <Box sx={{ p: 2 }}>{children}</Box>
        </motion.div>
      )}
    </AnimatePresence>
  );
}


export default function ExcelsheetUploadPage({ user }) {
  const [value, setValue] = useState(0);

  const hasFetched = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;
  }, []);

  const handleChange = (_, newValue) => setValue(newValue);

  const tabs = [
    { icon: <SchoolIcon />, label: "Student" },
    { icon: <SchoolIcon />, label: "Teacher" },
  ];

  const handleBack = () => {
    sessionStorage.setItem("hide", true);
    navigate(-1)
  };

  return (
    <div style={{ padding: 20 }}>
      <Box sx={{ width: "100%", backgroundColor: "#fafafa", minHeight: "100vh" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          // centered
          //variant="fullWidth"
          textColor="#3f2d01"
          indicatorColor="secondary"
          slotProps={{
            indicator: {
              sx: {
                backgroundColor: "#ff9800",
                height: "3px",
                borderRadius: "2px",
                transition: "background-color 0.3s ease",
              },
            },
          }}
          sx={{
            mb: 3,
            "& .MuiTab-root": {
              textTransform: "none",
              fontWeight: "bold",
              flexDirection: "row",
              gap: 1,
            },
          }}
        >
          {tabs.map((tab, i) => (
            <Tab
              key={i}
              icon={
                <motion.div
                  animate={{
                    scale: value === i ? 1.5 : 1,
                    color: value === i ? "#3f2d01" : "#757575",
                  }}
                  transition={{ type: "spring", stiffness: 300 }}
                >
                  {tab.icon}
                </motion.div>
              }
              label={tab.label}
              iconPosition="start"
            />
          ))}
        </Tabs>
        {user?.is_permited.Excel ? (<>
          {/* //  Tab 1: page */}
          <AnimatedTabPanel value={value} index={0}>
            <StudentExcelUpload />
          </AnimatedTabPanel>

          {/* //  Tab 2:  page */}
          <AnimatedTabPanel value={value} index={1}>
            <TeacherExcelUpload />
          </AnimatedTabPanel>
        </>) : <Typography >{"Your Plan not applicable for it"}</Typography>}
      </Box>
    </div>
  );
}